import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setOmsAutomationEnabled = {
  name: "setOmsAutomationEnabled" as const,
  input: z.object({ automationId: zExt.objectId(), enabled: z.boolean() }),
  output: z.object({}),
};
